<template>
	<div v-if="selectdItem.preStyle.selfStyle" style="height: 100%;width: 100%;">
	<!-- 	<div v-if="!selectdItem.preStyle.compontentStyle.width">
			空白宽度为0
		</div> -->
		<div
		 :style="{
		 	...getBorder(),
		 	...getBorderRadius(),
		 	...getBg(selectdItem),
			...getImgStyle(selectdItem)
		 }"
		 
		 style="max-width: 100%;"></div>
	</div>
</template>

<script>
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				
			}
		},
		methods:{
			cssStringToObject(cssString) {
				const styleObject = {};
			
				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');
			
				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');
			
				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});
			
				return styleObject;
			},
			getPadding(e) {
				let style = {
					paddingTop: e.preStyle.selfStyle.padding[0] + 'px',
					paddingBottom: e.preStyle.selfStyle.padding[1] + 'px',
					paddingLeft: e.preStyle.selfStyle.padding[2] + 'px',
					paddingRight: e.preStyle.selfStyle.padding[3] + 'px'
				}
				return style
			},
			getBg(e) {
				let style = {}
				if (e.preStyle.selfStyle.bg.color  && e.preStyle.selfStyle.bg.bgtype == 'color') {
					style.background = e.preStyle.selfStyle.bg.color
				}
				if (e.preStyle.selfStyle.bg.bgtype && e.preStyle.selfStyle.bg.bgtype == 'img') {
					if (e.preStyle.selfStyle.bg.img) {
				
						let backgroundImage = `url(${e.preStyle.selfStyle.bg.img})`
				
						if (e.preStyle.selfStyle.bg.bgImgWidth) {
							style.backgroundSize = e.preStyle.selfStyle.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (e.preStyle.selfStyle.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.selfStyle.bg.bgImgHeigth + 'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
						if (e.preStyle.selfStyle.bg.position) {
							style.backgroundPosition = e.preStyle.selfStyle.bg.position
						}
						style.backgroundImage = backgroundImage
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
					}
				}
				if (e.preStyle.selfStyle.bg.bgtype == 'gradient') {
					style = {
						...style,
						...this.cssStringToObject(e.preStyle.selfStyle.bg.bgGradient)
					}
				}
				
				return style
			},
			
			
			getBorderRadius() {
				let style = {}
				style.borderRadius =
					`${this.selectdItem.preStyle.selfStyle.border.borderRadius[0]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[1]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[2]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[3]}px`
				console.log('getBorderRadius', style)
				return style
			},
			getBorder() {
				if (this.selectdItem.preStyle.selfStyle.border.type && this.selectdItem.preStyle.selfStyle.border.color) {
					let style = {}
					style.borderTop =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[0]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderLeft =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[1]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderBottom =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[2]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderRight =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[3]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					return style
				}
			},
			
			
			getImgStyle(e) {
				console.log('getChildConentStyle e', e)
				// 文字渐变
				let style = {}
				if (e.preStyle.compontentStyle.needHW && this.equipment == 'pc') {
					if (e.preStyle.compontentStyle.percentWidthSwitch) {
						// style.width = '100%'
						style.width = e.preStyle.compontentStyle.width + 'px'
					} else {
						style.width = e.preStyle.compontentStyle.width + 'px'
					}
					style.height = e.preStyle.compontentStyle.height + 'px'
				}
				if (e.preStyle.compontentStylePhone.needHW && this.equipment == 'phone') {
					if (e.preStyle.compontentStylePhone.percentWidthSwitch) {
						// style.width = '100%'
						style.width = e.preStyle.compontentStylePhone.width + 'px'
					} else {
						style.width = e.preStyle.compontentStylePhone.width + 'px'
					}
					style.height = e.preStyle.compontentStylePhone.height + 'px'
				}
				console.log('getChildConentStyleegetImgStyle', style)
				return style
			},
		}
	}
</script>

<style>
</style>